module.exports = __webpack_public_path__ + "media/Logo/Logo-96e73b6e.svg";